<!-- Mobile -->
<div class="d-block d-md-none ws-filter-bar__mobile">
  @if (showMobileFilters) {
    <search-cakes-panel-mobile
      [filters]="model"
      [excludingFilters]="excludingFilters"
      (onClose)="mobileFiltersOpenChange(false); onApply($event)"
      (onReset)="onReset()"
    ></search-cakes-panel-mobile>
  }

  @if (showMobileDeliveryCheck) {
    <div class="d-md-none ws-filter-bar__delivery-overlay">
      <div class="container">
        <div class="text-end mt-3">
          <i class="icon-close" (click)="showMobileDeliveryCheck = false;"></i>
        </div>
        <post-number-delivery-check
          [countryCode]="countryCode"
          [postNumberChecker]="bakeryApi.getBakeriesByCityPostNumber.bind(bakeryApi)"
          (onCityChosen)="showMobileDeliveryCheck = false; onLocationFound.emit($event);"
          (onPostNumberChosen)="showMobileDeliveryCheck = false; onPostNumberChosen.emit($event)">
        </post-number-delivery-check>
      </div>
    </div>
  }

  @if ((model.canHasMotive && !hiddenFilters?.canHasMotive) ||
       (model.allergens?.length && !hiddenFilters?.allergens) ||
       (model.productGroups?.length && !hiddenFilters?.productGroups) || !hiddenFilters?.postNumber) {
    <div class="ws-filter-bar__mobile-actions d-sm-flex justify-content-between">
      <button class="ws-filter-chip ws-filter-bar__mobile-toggle"
              (click)="mobileFiltersOpenChange(true)">
        <i class="icon-filters ws-filter-bar__mobile-toggle-icon"></i>
        <span class="ps-2" [translate]="'orderProcess.cakesOverview.searchCakesPanel.cakeFilter'"></span>
      </button>

      <ng-content select=".right-side-mobile"></ng-content>
    </div>
  }
</div>

<!-- Desktop -->
<div class="d-none d-md-flex justify-content-between ws-filter-bar">
  <div class="ws-filter-bar__list">
    @if (model.allergens?.length && !hiddenFilters?.allergens) {
      <ui-multi-select
        class="ui-select-slim ws-filter-bar__filter"
        [placeholder]="('orderProcess.cakesOverview.searchCakesPanel.allergens' | translate)"
        [model]="model.allergens"
        (modelChange)="model.allergens = $event; filtersChanged$.next(undefined)"
        (openChange)="multiSelectOpenChange('allergens', $event)"
      ></ui-multi-select>
    }

    @if (model.canHasMotive && !hiddenFilters?.canHasMotive) {
      <ui-checkbox-btn class="ws-filter-bar__filter"
                       [model]="model.hasMotive"
                       (modelChange)="onMotiveChange($event)">
        <span class="ws-filter-chip__content">
          <i class="icon-account-box ws-filter-chip__icon"
             [class.ws-filter-chip__icon--active]="model.hasMotive"></i>
          <span>{{'orderProcess.cakesOverview.searchCakesPanel.motive' | translate}}</span>
        </span>
      </ui-checkbox-btn>
    }

    @if (!hiddenFilters?.postNumber) {
      <delivery-check-panel
        class="ws-filter-bar__filter ws-filter-bar__delivery-check"
        [postNumberChecker]="bakeryApi.getBakeriesByCityPostNumber.bind(bakeryApi)"
        (onPostNumberChosen)="onPostNumberChosen.emit($event)"
        (onDifferentLocationFound)="onLocationFound.emit($event)"
        [countryCode]="countryCode"
        [cityName]="getDashed(refName)">
      </delivery-check-panel>
    }

    @if (model.productGroups?.length && !hiddenFilters?.productGroups) {
      @for (group of linkGroups; track group.value) {
        <button class="ws-filter-bar__filter ws-filter-chip"
                [class.ws-filter-chip--active]="group.checked"
                (click)="$event.preventDefault(); selectGroup(group)">
          {{ group.label }}
        </button>
      }

      @if (dropdownGroups && dropdownGroups.length) {
        <div ngbDropdown #dropdown="ngbDropdown"
             class="ws-filter-bar__filter ws-filter-bar__more"
             (click)="$event.stopPropagation()">
          <button class="ws-filter-chip ws-filter-chip--dropdown ws-filter-bar__more-toggle"
                  ngbDropdownToggle
                  [class.ws-filter-chip--active]="selectedDropdownGroup">
            {{ selectedDropdownGroup ? selectedDropdownGroup.label : ('common.showMore' | translate) }}
          </button>
          <div class="dropdown-menu ws-dropdown ws-filter-bar__more-menu" ngbDropdownMenu>
            @for (group of dropdownGroups; track group.value) {
              @if (!group.checked) {
                <span class="dropdown-item ws-dropdown__item ws-filter-bar__more-item"
                      (click)="$event.preventDefault(); dropdownSelectCategory(group); dropdown.close()">
                  {{ group.label }}
                </span>
              }
            }
          </div>
        </div>
      }
    }
  </div>

  <ng-content select=".right-side"></ng-content>
</div>
